import * as React from "react";

import {Checkbox, Flag, Image, Input, Label, Pagination, Segment, Table, TextArea} from "semantic-ui-react";

import {IStateProperty} from "../../../components/StateViewBar";
import {OptionDto, OptionTextDto, OptionWorkflowStatusMultiUpdateParamActionType} from "../../../services/Client";
import {getWFStatusImageSrc, handleStepName} from "../../../components/Table/components/workflow/WorkFlowState";

import DataAdapterOptionsView from "../DataAdapterOptionsView";

import {SelectType} from "./WSMUSummaryUtils";

export interface IWSMUSummaryTableProps {
    actionType: OptionWorkflowStatusMultiUpdateParamActionType;
    totalItems: DataAdapterOptionsView[];
    tablePage: number;
    t: reactI18Next.TranslationFunction;
    onChangePage: (pageNumber: number) => void;

    // only for valid items table
    validFlag?: boolean;
    itemsToUpdate?: Map<number, OptionDto>;
    handleSelectChange?: (actionType: SelectType, optionDto?: OptionDto) => void;
}

const getTableHeaderCells = (t: reactI18Next.TranslationFunction) => {
    return (
        <>
            <Table.HeaderCell>{t("PSL_WF_S_MULTI:OPTION_IDENTIFIER")}</Table.HeaderCell>
            <Table.HeaderCell>{t("PSL_WF_S_MULTI:SHORTTEXT")}</Table.HeaderCell>
            <Table.HeaderCell>{t("PSL_WF_S_MULTI:CURRENT_STATUS")}</Table.HeaderCell>
        </>
    );
};

const getIdentifierCellData = (optionCode: string, optionType?: string) => {
    return (
        <Label size={'large'} className={'whitespace--nowrap'}>
            {optionCode}
            <Label.Detail>
                {optionType}
            </Label.Detail>
        </Label>
    );
};

const getTextsCellData = (texts: OptionTextDto[]) => {
    texts = texts.filter((p) => {
        if (p.language) {
            return p.language.code === 'cc' || p.language.code === 'de';
        }
        return true;
    });
    return (
        <Segment.Group horizontal={true}>
            {texts.sort((a, b) =>
                (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                .map((txt: OptionTextDto, idx: number) =>
                    <Segment
                        key={"txt-" + idx}
                        className={'texts-segment'}
                    >
                        <Flag
                            name={txt.language && txt.language.code === "de" ? "de" : "gb"}
                            className={'texts-flag'}

                        />
                        {txt.shorttext ? txt.shorttext : ""}
                    </Segment>
                )}
        </Segment.Group>
    );
};
const getCurrentStatusCellData = (statusValueState?: number, statusValueStates?: IStateProperty[]): JSX.Element => {
    const currentStep = statusValueState && statusValueStates ?
        statusValueStates.find((element) => element.id === statusValueState) : undefined;

    return (
        <>
            {currentStep &&
                <div>
                    <div className='workflow-status'>{handleStepName(currentStep.hoverText, currentStep.rejectReason, false)}</div>
                    <Image
                        className='margin-top--10px'
                        centered={true}
                        src={getWFStatusImageSrc(currentStep.type)}
                        width={30}
                        height={30}
                    />
                </div>
            }
        </>
    );
};

const getTablePagination = (invalidTablePage: number, totalItemsCount: number, onChangePage: (pageNumber: number) => void) => {
    return (
        <Pagination
            activePage={invalidTablePage}
            totalPages={Math.ceil(totalItemsCount / 10)}
            onPageChange={(e, c) => onChangePage(c.activePage as number)}
        />
    );
};

export const WSMUSummaryTable: React.StatelessComponent<IWSMUSummaryTableProps> = (props: IWSMUSummaryTableProps) => {
    const allSelected = props.validFlag && props.totalItems.every((val) => props.itemsToUpdate !== undefined && props.itemsToUpdate.has(val.dto.objectId));
    const items = props.totalItems.slice((props.tablePage - 1) * 10, props.tablePage * 10);

    return (
        <Table
            id={'psl-wsmu-summary-table'}
            celled={true}
            structured={true}
            textAlign={'center'}
        >
            <Table.Header>
                <Table.Row>
                    {props.validFlag &&
                        <Table.HeaderCell>
                            <Checkbox
                                slider={true}
                                checked={allSelected}
                                onChange={() => props.handleSelectChange && props.handleSelectChange(allSelected ? SelectType.DeselectAll : SelectType.SelectAll)}
                            />
                        </Table.HeaderCell>}
                    {getTableHeaderCells(props.t)}
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {items.map((item: DataAdapterOptionsView, index: number) => {
                    return (
                        <Table.Row key={'row-' + index}>
                            {props.validFlag &&
                                <Table.Cell>
                                    <Checkbox
                                        slider={true}
                                        checked={props.itemsToUpdate && props.itemsToUpdate.has(item.dto.objectId)}
                                        onChange={() => props.handleSelectChange && props.handleSelectChange(SelectType.SingleSelect, item.dto)}
                                    />
                                </Table.Cell>}
                            <Table.Cell>
                                {getIdentifierCellData(item.optionBasicView, item.optionTypeView)}
                            </Table.Cell>
                            <Table.Cell>
                                {getTextsCellData(item.texts)}
                            </Table.Cell>
                            <Table.Cell>
                                {getCurrentStatusCellData(item.statusValueState, item.statusValueStates)}
                            </Table.Cell>
                        </Table.Row>
                    );
                })}
            </Table.Body>

            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan={props.validFlag ? 4 : 3}>
                        {getTablePagination(props.tablePage, props.totalItems.length, props.onChangePage)}
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowStatusMultiUpdate/WSMUSummaryTable.tsx